import gql from 'graphql-tag'

export const INFO_USUARIO_QUERY = gql`
  query InfoUsuarioQuery($usuarioId: ID!) {
    infoUsuario(usuarioId: $usuarioId) {
      id
      dataAdmissao
      emailSuperior
      desligamento {
        id
        motivo
      }
      dataDesligamento
    }
  }
`
